/* ASL v12: "Hârtie vs apă" as a roll count. No dependencies, no pinning.
   - the rolls a smart toilet saves fade out one by one while the grid crosses the screen (both directions);
   - the big count follows the same scroll, from a year with a classic toilet to the same year with ASL;
   - the three numbers count up once, when they are on screen.
   The HTML already shows the finished state, so with reduced motion or without JS nothing changes. */
(() => {
  if (window.__aslV12) return;
  window.__aslV12 = true;
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const clamp = (v) => Math.min(1, Math.max(0, v));
  const fmt = (n) => (n >= 1000 ? `${Math.floor(n / 1000)}.${String(n % 1000).padStart(3, "0")}` : String(n));

  const econ = (sec) => {
    if (reduce || sec.__aslEcon) return;
    const grid = sec.querySelector("[data-econ-grid]");
    const count = sec.querySelector("[data-econ-count]");
    if (!grid || !count) return;
    sec.__aslEcon = true;

    const from = +sec.dataset.from || 0, to = +sec.dataset.to || 0;
    // the saved rolls go from the end of the pile back towards the ones that stay
    const gone = [...grid.querySelectorAll(".asl-econ__roll:not(.is-kept)")].reverse();
    const A = 0.06, B = 0.86; // part of the scroll in which the rolls go
    let last = -1, raf = 0;

    // 0 when the top of the grid is low on the screen, 1 when the whole grid sits in the upper half
    const progress = () => {
      const r = grid.getBoundingClientRect(), vh = innerHeight;
      const start = vh * 0.9, end = vh * 0.58 - r.height;
      return clamp((start - r.top) / (start - end));
    };
    const render = (p) => {
      const k = clamp((p - A) / (B - A));
      gone.forEach((el, i) => el.classList.toggle("is-gone", k > (i + 0.5) / gone.length));
      count.textContent = fmt(Math.round(from - (from - to) * k));
      sec.classList.toggle("is-done", k >= 1);
    };
    const tick = () => {
      raf = 0;
      const p = progress();
      if (Math.abs(p - last) > 0.0005) { last = p; render(p); }
    };
    const queue = () => { if (!raf) raf = requestAnimationFrame(tick); };

    sec.classList.add("is-live");
    render(progress());
    // listen to the scroll only while the section is near the screen
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(([e]) => {
        if (e.isIntersecting) { addEventListener("scroll", queue, { passive: true }); queue(); }
        else removeEventListener("scroll", queue);
      }, { rootMargin: "25% 0px" }).observe(sec);
    } else addEventListener("scroll", queue, { passive: true });
    addEventListener("resize", queue);

    // the three numbers: count up once, when at least half of them is visible
    const stats = [...sec.querySelectorAll("[data-econ-to]")];
    const show = (el, v) => { el.textContent = `${el.dataset.pre || ""}${fmt(v)}${el.dataset.suf || ""}`; };
    const run = (el) => {
      const target = +el.dataset.econTo || 0, t0 = performance.now(), dur = 1300;
      const step = (t) => {
        const x = clamp((t - t0) / dur), e = 1 - Math.pow(1 - x, 3);
        let v = Math.round(target * e);
        if (target >= 100 && x < 1) v = Math.round(v / 10) * 10; // money and rolls tick in tens, then land
        show(el, x < 1 ? v : target);
        if (x < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if ("IntersectionObserver" in window) {
      stats.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.top < innerHeight && r.bottom > 0) return; // already on screen at load: keep the final numbers
        show(el, 0);
        const io = new IntersectionObserver(([e]) => {
          if (!e.isIntersecting) return;
          io.disconnect();
          run(el);
        }, { threshold: 0.5 });
        io.observe(el.closest(".asl-econ__stat") || el);
      });
    }
  };

  const init = (root) => root.querySelectorAll("[data-asl-econ]").forEach(econ);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => init(document));
  else init(document);
  document.addEventListener("shopify:section:load", (e) => init(e.target));
})();
